import { format } from 'date-fns'

export const getWordCount = (text: string) => text.trim().split(/\s+/).length
export const getWordCountFormatted = (text: string) => getWordCount(text).toLocaleString()

// Helper function to format date for conversation
export const formatDateForConversation = (date: number | string | Date): string => {
  if (date === undefined) return ''
  if (typeof date === 'number') return new Date(date).toISOString()
  if (typeof date === 'string') return date
  return date.toISOString()
}

export function formatAudioNoteTitle(originalTitle: string | undefined, endDate?: Date) {
  const formattedEndDate = endDate ? format(endDate, 'MMM d') : undefined

  if (!originalTitle && !endDate) return 'Meeting Note'

  if (!originalTitle || originalTitle.startsWith('Meeting Note')) {
    return formattedEndDate ? `Meeting Note · ${formattedEndDate}` : 'Meeting Note'
  }

  // handle titles from cloud sync that include "from" and full date and legacy "Audio Note"
  if (originalTitle.startsWith('Meeting Note from')) {
    return formattedEndDate ? `Meeting Note · ${formattedEndDate}` : 'Meeting Note'
  }

  if (originalTitle.startsWith('Audio Note')) {
    return formattedEndDate ? `Meeting Note · ${formattedEndDate}` : 'Meeting Note'
  }

  if (originalTitle.startsWith('Google Meet')) {
    return formattedEndDate ? `Google Meet · ${formattedEndDate}` : 'Google Meet'
  }

  if (originalTitle.startsWith('Zoom')) {
    return formattedEndDate ? `Zoom · ${formattedEndDate}` : 'Zoom'
  }

  return originalTitle
}

/**
 * Strips "Daily Summary" heading from markdown content
 */
export function stripDailySummaryTitle(content: string): string {
  return content.replace(/^#{1,6}\s*Daily Summary\s*\n?/im, '').trim()
}

export function formatBytes(bytes: number, decimals: number = 2): string {
  if (bytes === 0) {
    return '0 Bytes'
  }

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}
